module.exports = __webpack_public_path__ + "img/auth-bg-1 (2).bc403019.jpg";